import moment from "moment";

export function getAnimalMonths(
    animal,
    allMonthMap,
    inseminatedMonthMap,
    wasInseminated,
    currentCycle
) {
    const start = moment(animal.DtaInTime).startOf("month");
    const end = moment(animal.DtaDthTime || animal.DtaDelTime).endOf("month");
    do {
        const key = `${animal.Race || "unknown"}#${currentCycle}#${start.format(moment.HTML5_FMT.DATE)}`;
        allMonthMap[key] = (allMonthMap[key] || 0) + 1;
        if (wasInseminated) {
            inseminatedMonthMap[key] = (inseminatedMonthMap[key] || 0) + 1;
        }
        start.add(1, "month");
    } while (start.isBefore(end));
}

export function createInventoryParameter(
    key,
    value,
    type,
    inventoryKey,
    category
) {
    const [race, cycle, dateString] = inventoryKey.split("#");
    const date = moment.utc(dateString);
    return {
        key,
        value,
        type,
        category,
        dataEv: +date,
        day: date.isoWeekday(),
        month: date.month(),
        week: date.isoWeek(),
        year: date.year(),
        race: race === "unknown" ? undefined : race,
        cycle: +cycle,
    };
}
